// extracted by mini-css-extract-plugin
export default {"list":"Ppf_list__x3JJQ","tab":"Ppf_tab__GiaCC"};